import React from 'react';

import { ThemeWrapper } from '@nutanix-core/prism-ui-themes-common';

export default function ThemeProvider({ children }: { children: React.ReactNode }) {
  return <ThemeWrapper onThemeChange={() => ({})}>{children}</ThemeWrapper>;
}
